import GGButton from '../../../CommonComponents/GGButton/GGButton'
import { Inventory } from '@mui/icons-material'
import { CustomMessageOrderMetaDetails } from '../GGCustomMessageTypes'
import { SessionManager } from '../../../../services/SessionManager/SessionManager'
import { useNavigate } from 'react-router-dom'
import { useMediaQuery, useTheme } from '@mui/material'

interface OrderSubmittedBySellerCardProps {
    orderId: string,
    orderMetaData: CustomMessageOrderMetaDetails
}

const OrderSubmittedBySellerCard = ({ orderId, orderMetaData }: OrderSubmittedBySellerCardProps) => {
    const navigate = useNavigate()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isCurrentUserBuyer = orderMetaData?.buyerId === SessionManager.shared.buyer?.id

    const getResponsiveStyles = () => ({
        orderCompleteWrapper: {
            width: '100%', 
            padding: isMobile ? '1rem' : '2rem', 
            borderRadius: isMobile ? '8px' : '10px', 
            backgroundColor: '#ddead5', 
            marginTop: isMobile ? '0.5rem' : '1rem'
        },
        orderCompleteHeadline: {
            fontWeight: 'bold', 
            fontSize: isMobile ? '1.2rem' : '1.5rem'
        },
        orderCompleteContent: {
            padding: isMobile ? '1rem' : '2rem', 
            borderRadius: isMobile ? '8px' : '10px', 
            backgroundColor: 'white', 
            margin: isMobile ? '0.75rem 0rem' : '1rem 0rem', 
            lineHeight: '1.7rem', 
            fontSize: isMobile ? '0.8rem' : '0.9rem'
        },
        orderCompleteViewButton: {
            marginTop: isMobile ? '0.75rem' : '1rem',
            fontSize: isMobile ? '11px' : '12px',
            letterSpacing: '0px',
            backgroundImage: 'linear-gradient(to right, #3FA600, #358107)',
            color: 'white'
        }
    });

    const orderCompleteStyle = getResponsiveStyles();

    if (isCurrentUserBuyer) {
        return (
            <div className="orderCompleteWrapper" style={{ ...orderCompleteStyle.orderCompleteWrapper }}>
                <div className="orderCompleteHeadline" style={{ ...orderCompleteStyle.orderCompleteHeadline, textAlign: 'center' }}>Your order is marked complete by freelancer!</div>
                <div className="orderCompleteContent" style={{ ...orderCompleteStyle.orderCompleteContent, textAlign: 'center' }}>
                    <div>Please click below to verify and complete your order</div>
                    <div><GGButton onClick={() => navigate("/order-details/" + orderId)} className='orderCompleteViewButton' variant="contained" size="small" startIcon={<Inventory />} style={{ ...orderCompleteStyle.orderCompleteViewButton }}>View Order</GGButton></div>
                </div>
            </div>
        )
    }
    else return (
        <div className="orderCompleteWrapper" style={{ ...orderCompleteStyle.orderCompleteWrapper }}>
            <div className="orderCompleteHeadline" style={{ ...orderCompleteStyle.orderCompleteHeadline, textAlign: 'center' }}>You marked this order completed!</div>
            <div className="orderCompleteContent" style={{ ...orderCompleteStyle.orderCompleteContent, textAlign: 'center' }}>
                <div>Action pending from client end</div>
                <div><GGButton onClick={() => navigate("/freelancer-dashboard/workspace")} className='orderCompleteViewButton' variant="contained" size="small" startIcon={<Inventory />} style={{ ...orderCompleteStyle.orderCompleteViewButton }}>View Order</GGButton></div>
            </div>
        </div>
    )
}

export default OrderSubmittedBySellerCard